import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain ,isKsDomain, isSaficDomain } from 'utils/domain'

import Icon, { IconProps } from './Icon'

/**
 * エラーの泣き顔アイコン
 */
const ErrorIcon: React.FC<IconProps> = (props) => {
  const color = isKsDomain() ? 'var(--color-text)' : isSaficDomain() ? 'var(--color-text-for-main-background)' : {
    [DOMAIN.SJ]: 'var(--color-text)',
  }[getDomain()]

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100.001"
        height="99.999"
        viewBox="0 0 100.001 99.999"
      >
        <path
          fill={color}
          d="M-867-7467a49.67,49.67,0,0,1-35.355-14.644A49.674,49.674,0,0,1-917-7517a49.676,49.676,0,0,1,14.646-35.357A49.677,49.677,0,0,1-867-7567a49.677,49.677,0,0,1,35.355,14.644A49.677,49.677,0,0,1-817-7517a49.675,49.675,0,0,1-14.646,35.355A49.671,49.671,0,0,1-867-7467Zm0-94.141a43.86,43.86,0,0,0-31.213,12.929A43.851,43.851,0,0,0-911.14-7517a43.849,43.849,0,0,0,12.927,31.211A43.86,43.86,0,0,0-867-7472.859a44.207,44.207,0,0,0,13.9-2.224,43.65,43.65,0,0,0,12.378-6.444,13.1,13.1,0,0,1-7.333-4.506,13.044,13.044,0,0,1-2.937-8.231,18.228,18.228,0,0,1,1.379-6.1A33.861,33.861,0,0,0-867-7504.9c-8.44,0-16.408,2.813-21.315,7.524l-4.058-4.226c6.062-5.821,15.311-9.159,25.373-9.159a42.945,42.945,0,0,1,10.423,1.257,36.255,36.255,0,0,1,9.183,3.639c.542-1.228,1.128-2.507,1.741-3.8,2.449-5.165,4.861-9.615,5.128-10.1l2.572-4.715,2.571,4.713,0,0c.268.493,2.69,4.963,5.125,10.1a99.2,99.2,0,0,1,4.051,9.573A43.913,43.913,0,0,0-822.86-7517a43.846,43.846,0,0,0-12.929-31.213A43.851,43.851,0,0,0-867-7561.142Zm29.048,49.076c-3.469,6.84-7.175,15.108-7.175,17.8a7.183,7.183,0,0,0,7.175,7.175,7.183,7.183,0,0,0,7.175-7.175c0-2.694-3.706-10.962-7.175-17.8h0Zm-13.523-9.826a11.519,11.519,0,0,1-11.506-11.506h5.859a5.611,5.611,0,0,0,1.656,3.992,5.61,5.61,0,0,0,3.992,1.656,5.653,5.653,0,0,0,5.646-5.648h5.861A11.519,11.519,0,0,1-851.475-7521.892Zm-31.05,0a11.519,11.519,0,0,1-11.506-11.506h5.861a5.612,5.612,0,0,0,1.656,3.992,5.607,5.607,0,0,0,3.99,1.656,5.654,5.654,0,0,0,5.648-5.648h5.859A11.519,11.519,0,0,1-882.525-7521.892Z"
          transform="translate(917 7567)"
        />
      </svg>
    </Icon>
  )
}

export default ErrorIcon
